import React from 'react';

 const SkillPage = () => {
  return (
  <>
  <div class="skills" id="skills">
        <div class="skills-heading">
            <h1>My Skills</h1>
            <h4>what i know</h4>
        </div>
        <div class="skills-content">
            <div class="skills-content-left">
                <h2>My creative skills & experiences.</h2>
                <p>My expertise is in the area of responsive websites. With every line of code, I strive to make the
                    website
                    a beautiful place. I've got a diverse set of skills ranging from HTML to CSS + javascript, all the
                    way to PHP and MySql. I also have experience with frontend frameworks like jQuery and Reactjs. I've
                    hands-on solid object-oriented programming in C, C++, and python. I'm well-versed in a multitude of
                    programming languages. I have developed a few websites for personal and small companies that include
                    custom plugins and widgets. I am a motivated and hardworking individual with excellent
                    communicational skills. I enjoy designing and building beautiful, responsive websites for
                    entrepreneurs and small businesses to help their businesses grow.</p>
            </div>
            <div class="skills-content-right">
                <p>Html</p>
                <p>Css</p>
                <p>JavaScript</p>
                <p>PHP</p>
                <p>Python</p>
                <p>MySQL</p>
                <p>C++</p>
                <p>C</p>


            </div>
        </div>
    </div>
  
  </>
  );
};
export default SkillPage;